// src/components/pages/TermsOfServicePage.js
import React from "react";
import "../../styles/legal.css";
import { Helmet } from "react-helmet-async";

export default function TermsOfServicePage() {
  return (
    <>
    <Helmet>
  <title>Terms of Service – PracVerse</title>
  <link rel="icon" href="/favicon.ico" />
<link rel="shortcut icon" href="/favicon.ico" />
<link rel="apple-touch-icon" href="/favicon.ico" />

  <meta
    name="description"
    content="Read the terms and conditions for using the PracVerse website and participating in our drone education programs."
  />
  <link rel="canonical" href="https://www.pracverse.com/terms-of-service" />

  <meta property="og:title" content="Terms of Service – PracVerse" />
  <meta
    property="og:description"
    content="Terms and conditions for accessing PracVerse services and courses."
  />
  <meta property="og:url" content="https://www.pracverse.com/terms-of-service" />

  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "Terms of Service – PracVerse",
      "url": "https://www.pracverse.com/terms-of-service",
      "about": "Terms of Service"
    })}
  </script>
</Helmet>

    <main className="legal-page">
      <section className="legal-hero">
        <div className="container">
          <h1>Terms of Service</h1>
          <p>Last updated: 30 November 2025</p>
          <p>
            By accessing or using the PracVerse website, courses or services,
            you agree to these Terms of Service. Please read them carefully.
          </p>
        </div>
      </section>

      <section className="legal-content">
        <div className="container">
          <h2>1. Acceptance of Terms</h2>
          <p>
            These Terms of Service (&quot;Terms&quot;) apply to your use of the
            PracVerse website, educational content, workshops and related
            services. If you do not agree with these Terms, please do not use
            our services.
          </p>

          <h2>2. Services We Provide</h2>
          <p>PracVerse provides:</p>
          <ul>
            <li>Drone-based education programs and workshops</li>
            <li>Online and offline training content and resources</li>
            <li>STEM and technology-learning support for institutions</li>
          </ul>
          <p>
            We may modify, add, or discontinue parts of our services at any
            time, with or without notice.
          </p>

          <h2>3. User Responsibilities</h2>
          <p>When using our website or services, you agree to:</p>
          <ul>
            <li>Provide accurate information in forms and communication</li>
            <li>
              Use our content and resources only for lawful, educational
              purposes
            </li>
            <li>
              Not upload or share any harmful, offensive, or illegal material
            </li>
            <li>
              Not attempt to damage, hack, or interfere with our systems or
              networks
            </li>
          </ul>
          <p>
            You acknowledge that drone use is governed by safety rules and
            regulations (including DGCA rules in India), and you agree to follow
            all applicable laws and institutional safety guidelines.
          </p>

          <h2>4. Intellectual Property</h2>
          <p>
            All content and materials on the PracVerse platform—including
            videos, tutorials, images, branding, curriculum content, and logos—
            are owned by PracVerse or its licensors and are protected by
            copyright and other intellectual property laws.
          </p>
          <p>You may not:</p>
          <ul>
            <li>Copy or redistribute content without written permission</li>
            <li>Sell, license, or commercially exploit our materials</li>
            <li>Remove or alter copyright or attribution notices</li>
          </ul>

          <h2>5. Payments &amp; Refunds</h2>
          <p>
            Payments for programs, workshops or services are processed through
            third-party payment providers. You agree to provide accurate billing
            information and authorise us or our partners to charge the
            applicable fees.
          </p>
          <p>
            Refunds, if any, will be handled according to the specific terms of
            the program or agreement shared with you at the time of booking.
          </p>

          <h2>6. Disclaimer of Warranties</h2>
          <p>
            Our services are provided on an &quot;as is&quot; and &quot;as
            available&quot; basis. While we strive for high-quality content and
            learning experiences, we do not guarantee:
          </p>
          <ul>
            <li>Specific learning outcomes or academic results</li>
            <li>That the website will be error-free or always available</li>
            <li>
              That all information is fully complete, current, or free from
              typographical errors
            </li>
          </ul>

          <h2>7. Limitation of Liability</h2>
          <p>
            To the maximum extent permitted by law, PracVerse will not be liable
            for any indirect, incidental, special or consequential damages
            arising from your use of our website or services.
          </p>
          <p>
            Our total aggregate liability for any claim will not exceed the
            total amount you have paid to us for the relevant service.
          </p>

          <h2>8. Drone Safety &amp; Compliance</h2>
          <p>
            Drone flying and experimentation must always be conducted under
            proper supervision, using approved equipment and following all
            safety and regulatory guidelines.
          </p>
          <p>
            PracVerse is not responsible for any accidents, damage or legal
            issues that result from misuse of drones, equipment or information
            provided in our programs.
          </p>

          <h2>9. Termination</h2>
          <p>
            We may suspend or terminate your access to any or all of our
            services if:
          </p>
          <ul>
            <li>You breach these Terms</li>
            <li>You engage in fraudulent or harmful behaviour</li>
            <li>We are required to do so by law or regulation</li>
          </ul>

          <h2>10. Governing Law</h2>
          <p>
            These Terms are governed by the laws of India. Any disputes will be
            subject to the exclusive jurisdiction of the courts located in
            Mumbai, Maharashtra, unless otherwise required by applicable law.
          </p>

          <h2>11. Changes to These Terms</h2>
          <p>
            We may update these Terms from time to time. When we do, we will
            revise the &quot;Last updated&quot; date at the top of this page.
            Your continued use of our services after changes are posted will
            mean you accept the updated Terms.
          </p>

          <h2>12. Contact Us</h2>
          <p>
            For questions about these Terms, please contact us at{" "}
            <a href="mailto:contact@pracverse.com">contact@pracverse.com</a>.
          </p>
        </div>
      </section>
    </main>
    </>
  );
}
